import { render } from "./ItemUniqueOption.vue?vue&type=template&id=923008f6"
import script from "./ItemUniqueOption.vue?vue&type=script&lang=js"
export * from "./ItemUniqueOption.vue?vue&type=script&lang=js"

import "./ItemUniqueOption.vue?vue&type=style&index=0&id=923008f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__